import axios from "@/libs/api.request";
export function getProductType() {
    return axios.request({
        // url: "ProductType/getProductTypeList",
        url: "ProductType/getProductTypeList",
        method: "get",
    })
}
export function getProductTypeNum(params) {
    return axios.request({
        url: "ProductType/getProductTypeNum",
        method: "get",
        params:params,
    })
}

export function submitProductType(params) {
    return axios.request({
        url: "ProductType/setProductTree",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}
//获取系列信息
export function getProductMainCode(params) {
    return axios.request({
        url: "ProductMainCode/getMainCodeList",
        method: "get",
        params:params
    })
}
// 添加/修改系列信息
export function addProductMainCode(params) {
    return axios.request({
        url: "ProductMainCode/CreateUpdate",
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}

// // 修改系列信息
// export function editProductMainCode() {
//     return axios.request({
//         url: "ProductMainCode/Create",
//         method: "get",
//     })
// }

// 删除系列信息
export function delProductMainCode(id) {
    return axios.request({
        url: "ProductMainCode/Delete",
        method: "post",
        params:{id:id}
    })
}


//获取产品信息
export function getProductMain(params) {
    return axios.request({
        url: "Product/getProductAllList",
        method: "get",
        params:params,
    })
}
// 添加/修改系列信息
export function addProduct(params) {
    return axios.request({
        url: "Product/CreateUpdate",
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}

// 删除系列信息
export function delProductInfo(id) {
    return axios.request({
        url: "Product/Delete",
        method: "post",
        params:{id:id}
    })
}

//获取图片
//获取产品信息
export function getProductPic(params) {
    return axios.request({
        url: "WebFileInfo/getFileAllList",
        method: "get",
        params:params
    })
}


//获取产品明细左侧
export function getProductDetailLeft(params) {
    return axios.request({
        url: "Product/GetProductDetailLeft",
        method: "get",
        params:params
    })
}
//获取产品明细图列表
export function getProductDetailImg(params) {
    return axios.request({
        url: "Product/GetProductDetailImg",
        method: "get",
        params:params
    })
}
//获取收藏列表
export function getFavoriteTree(params) {
    return axios.request({
        url: "WebFavorite/getFavTreeList",
        method: "get",
        params:params
    })
}
//获取收藏列表
export function getFavoriteList(params) {
    return axios.request({
        url: "WebFavorite/getFavoritList",
        method: "get",
        params:params
    })
}
// 添加/修改收藏信息
export function addFavorite(params) {
    return axios.request({
        url: "WebFavorite/CreateUpdate",
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}
// 删除收藏信息
export function delFavoriteInfo(id) {
    return axios.request({
        url: "WebFavorite/Delete",
        method: "post",
        params:{id:id}
    })
}
//获取收藏列表
export function sendUpdate(personID) {
    return axios.request({
        url: "WebFavorite/update",
        method: "post",
        params:{personID:personID}
    })
}
//获取产品信息
export function getUnionProduct(params) {
    return axios.request({
        url: "Product/GetUnionProduct",
        method: "get",
        params:params,
    })
}

//获取产品信息
export function getupdateSort(params) {
    return axios.request({
        url: "Product/updateSort",
        method: "get",
        params:params,
    })
}